export const REPORT_CONTAINER_TAG_NAME = 'report-container';
